jQuery(document).ready(function($) {
    $('.complex__slider').slick({
        appendArrows: $('.complex__slider__arrows'),
        prevArrow: '<a href="#" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></a>',
        nextArrow: '<a href="#" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></a>',
        speed: 800,
        autoplay: true,
        autoplaySpeed: 7000,

    });
    $('.complex__slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        var num = nextSlide + 1
        $('.complex__slider__nav li').removeClass('active')
        $('.complex__slider__nav li:nth-child(' + num + ')').addClass('active');
    });
});
$(document).on('mouseenter', '.complex__slider__nav li:not(.complex__slider__arrows)', function(event) {
    var num = $(this).index();
    $('.complex__slider').slick('slickGoTo', num, true);
});
